<template>
  <div>
    <v-layout 
      :justify-center="center"
      :class="{
        'text-xs-center': center
    }">
      <h3 class="primary--text text-uppercase textoAjustado"><slot></slot></h3>
    </v-layout>
    <v-layout row align-center justify-center mb-3>
      <v-divider class="dividerSubtitle primary"></v-divider>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'o-medium-title',
  props: {
    center: {
      type: Boolean,
      default: false
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/generic/titulos/OMediumTitle.vue